import React from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { companyAPI } from '../../api/services/company'
import invoicesSummary from '../../utils/invoices/invoicesSummary.ts'
import Button from '../common/Button/Button.tsx'

const GoToReportPage = ({
  fromDate,
  toDate
}: {
  fromDate: string
  toDate: string
}) => {
  const navigate = useNavigate()
  const handlePreview = async () => {
    try {
      const companyResponse = await companyAPI.getCompany()
      const company =
        companyResponse.status === 200 && companyResponse.data.length > 0
          ? companyResponse.data[0]
          : null
      if (!company) throw new Error('Nie znaleziono danych firmy')

      const allInvoices = await invoicesSummary(fromDate, toDate)
      if (!allInvoices || allInvoices.length === 0)
        throw new Error('Nie znaleziono faktur w podanym zakresie dat')

      if (allInvoices) {
        navigate('/payments/invoices/report', {
          state: {
            allInvoices,
            company,
            fromDate,
            toDate
          }
        })
      }
    } catch (error) {
      toast.error(error instanceof Error ? error.message : (error as string))
    }
  }
  return <Button
            variant="filled"
            size="medium"
            color="primary"
            type="submit"
            onClick={handlePreview}
          >
            {'Podgląd Raportu'}
          </Button>
}

export default GoToReportPage
